import { CommitteeDto } from './committee.dto';

export interface CommitteeMeetingDto {
  MeetingID: number;
  CommitteeID: number;
  Title: string;
  Purpose: string;
  MeetingDate: Date;
  MeetingTime: string;
  MeetingAgenda: string;
  MeetingMinutes: string;
  Notes: string;
  MeetingAddress1: string;
  MeetingAddress2: string;
  MeetingCity: string;
  MeetingState: string;
  MeetingZip: string;
  MeetingZipExt: string;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  MeetingAgendaS3Key: string;
  MeetingMinutesS3Key: string;

  Committee: CommitteeDto;
}

export function initializedCommitteeMeetingDto(committeeId?: number) {
  return {
    CommitteeID: committeeId,
    DateCreated: new Date(),
    DateChanged: new Date(),
  } as CommitteeMeetingDto;
}
